import React, {useState,useEffect} from 'react';

export const BuscadorLocalidad = (props) => {	
	const {ListaLocalidades, setLocalidad} = props;
	const [inputValue, setInputValue] = useState("");
    const [showLocalidades, setShowLocalidades] = useState(false);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setShowLocalidades(value.length >= 4);
		ListaLocalidades.forEach((localidad) => {
			if (localidad.nombre.toLowerCase() === value.toLowerCase()) {
				setLocalidad({...localidad});
			}
		});
    };

    const manejarSeleccionLocalidad = (localidad) => {
        setInputValue(`${localidad.nombre}, ${localidad.provincia?.nombre}`);
		setLocalidad({...localidad})
        setShowLocalidades(false);
    };

	const matchLocalidad = (input, nombreLocalidad) => {
        const normalize = (str) =>
            str
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, ""); // Elimina acentos

        const inputWords = normalize(input).split(" ");
        const localidadWords = normalize(nombreLocalidad).split(" ");

        return inputWords.every((word) =>
            localidadWords.some((localWord) => localWord.includes(word))
        );
    };

	return(
		<div className="position-relative w-100">
			<input
				className="form-control bg-white text-dark"
				type="text"
				placeholder="Ej. Almendralejo, Madrid, Barcelona..."
				value={inputValue}
				onChange={handleInputChange}
			/>
			{showLocalidades && (
				<ul className="dropdown-list dropdown-list-localidades">
					{ListaLocalidades.filter((localidad) =>
						matchLocalidad(inputValue, localidad.nombre)
					).map((localidad) => (
						<li
							key={`${localidad.id}-${localidad.provincia?.nombre}`}
							onClick={() => manejarSeleccionLocalidad(localidad)}
						>
							{localidad.nombre}, {localidad.provincia?.nombre}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
// 	const {Filtro, setFiltro, autLocalidades, setAutLocalidades} = props;

// 	const {localidad} = Filtro;

// 	//const [listaLocalidades, setListaLocalidades] = useState(ListaLocalidades);
// 	const listaLocalidades = [
// 		'Madrid',
// 		'Cáceres',
// 		'Badajoz',
// 		'Mérida',
// 		'Sevilla',
// 		'Almendralejo',
// 		'Barcelona',
// 		'Murcia',
// 	];

// 	const setLocalidad = (e) => {
// 		setFiltro({
// 			...Filtro,
// 			localidad: e,
// 		});
// 		setAutLocalidades(true);
// 	};

// 	return (
// 		<div className='desktopSearchPanelElement4'>
// 			<div className='centrador infoPrimario'>
// 				<b>Localidad</b>
// 			</div>
// 			<div className='searchLocalidad'>
// 				<input
// 					type='text'
// 					className='inputLocalidadMarketPlace'
// 					value={localidad}
// 					placeholder='Introduzca localidad de busqueda'
// 					onChange={(e) => setLocalidad(e.target.value)}
// 					onClick={() => {
// 						if (!autLocalidades) {
// 							setAutLocalidades(true);
// 						}
// 					}}
// 				/>
// 				<div className='autLocalidades'>
// 					{autLocalidades &&
// 						listaLocalidades.map(
// 							(item, key) =>
// 								item.toLowerCase().includes(localidad.toLowerCase()) && (
// 									<div
// 										className='localidadSearch centradorLeft'
// 										onClick={() => setLocalidad(item)}
// 									>
// 										{item}
// 									</div>
// 								)
// 						)}
// 				</div>
// 			</div>
// 		</div>
// 	);
// };
// /*
//                 <Autocomplete
//                     getItemValue={(item) => item.label}
//                     items={listaLocalidades}
//                     renderItem={(item, isHighlighted) =>
//                         <>{item.label}</>
//                     }
//                     value={localidad}
//                     onChange={(e) => setLocalidad(e.target.value)}
//                     onSelect={(val) => setLocalidad(val)}
//                 />
//                 */
